import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState = {
    id: '',
    name: '',
    offlineTranslation: false,
    documentProject: false,
    documentOrContentProject: false,
    contentProject: false,
    type: '',
    view: <null | 'single' | 'multi' | 'document'>null,
    search: <null | string>null,
    isBranchingEnabled: false,
    /**
     * 'platforms' is an array of all combinations of platforms present in the project.
     * Every element is a set of binary flags. Use bitwise operations to extract data.
     *
     * For example, to find out if Android platform is present, use:
     * `if (platforms.some(p => Number(p) & 2)) { ... }`
     *
     * Values:
     * - iOS = 1
     * - Android = 2
     * - Web = 4
     * - Other = 16
     *
     * See this thread for more context:
     * https://lokalise.slack.com/archives/C04CW8NJTJ5/p1674758707402799?thread_ts=1674758700.600439&cid=C04CW8NJTJ5
     */
    platforms: [] as string[],
    baseLanguageId: 0,
    baseLanguageLocale: '',
    projectRights: {
        activity: false,
        contributors: false,
        createBranches: false,
        download: false,
        manageKeys: false,
        manageLanguages: false,
        screenshots: false,
        settings: false,
        statistics: false,
        tasks: false,
        upload: false,
    },
};

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        addPlatforms: (state, { payload }: PayloadAction<{ platforms: string[] }>) => {
            const newPlatforms = payload.platforms.filter((newPlatformId) => !state.platforms.includes(newPlatformId));
            state.platforms = state.platforms.concat(newPlatforms);
        },
    },
});

export default projectSlice.reducer;
